import initialState from './initialState';
import * as types from '../actions/types';

export default function userReducer(state = initialState.userProps, action) {
    switch (action.type) {
        case types.LOAD_USER_SUCCESS:
            return action.userProps;        
        case types.LOAD_USER_FAILURE:
            return { ...state, error: action.userProps };
            default:
            return state;
    }
}
